import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listUser } from "../../Redux/Actions/userActions";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../api/baseConfig";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";
import ReactPaginate from "react-paginate";
import classes from './User.module.css'
import axios from "axios";
import { useCallback } from "react";

const UserComponent = () => {
  const [q, setQ] = useState("")
  const [page, setPage] = useState(1);
  const [subscriberCount, setSubscriberCount] = useState(0)
  const [asubscriberCount, setASubscriberCount] = useState(0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [option, setOption] = useState("email") // email, phone, paymentcode

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };


  const loadUsers = useCallback((page, q, option) => {
    setLoading(true)
    const user = JSON.parse(localStorage.getItem("userInfo"))
    axios.get(`${BASE_URL}/api/user/getalluser?page=${page}&q=${q}&option=${option}`, {
      headers: {
        'x-access-token': user.token
      }
    }).then(res => {
      setUsers(res.data)
      setLoading(false)
    }).catch(err => {
      setError(err.message)
      setLoading(false)
    })
  }, [])

  useEffect(() => {
    loadUsers(page, q, option)
  }, [loadUsers, page, q, option])

  const [disabledId, setDisabledId] = useState('')
  const onPartner = async (user) => {
    setDisabledId(user.id)
    if (window.confirm('Are you sure?')) {
      await fetch(`${BASE_URL}/api/partner/add`, {
        method: 'POST',
        body: JSON.stringify({
          user_id: user.id,
          partner_name: user.username
        }),
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('userInfo')).token
        }
      }).then(res => res.json())
        .then(data => alert(data.message))

    }
  }


  const loadContent = useCallback(() => {
    axios.get(`${BASE_URL}/api/user/getalluser?claims=Subscriber&page=1`, {
      headers: {
        'x-access-token': JSON.parse(localStorage.getItem('userInfo')).token
      }
    }).then(res => {
      setSubscriberCount(res.data.total)
    })

    axios.get(`${BASE_URL}/api/user/getalluser?claims=Subscriber&status=active&page=1`, {
      headers: {
        'x-access-token': JSON.parse(localStorage.getItem('userInfo')).token
      }
    }).then(res => {
      setASubscriberCount(res.data.total)
    })
  }, [])
  
  useEffect(() => {
    loadContent(page)
  }, [loadContent, page])


  return (
    <section className="content-main">
      <div className="content-header">
        <h2 className="content-title">Customers</h2>
      </div>
      <div className="card mb-4">
        <header className="card-header">
          <div className="row gx-3">
            <div className="col-lg-4 col-md-6">
              <input
                type="text"
                placeholder="Search..."
                className="form-control"
                value={q}
                onChange={e => setQ(e.target.value.toLowerCase())}
              />
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="input-group">
                <select
                  className="form-select custom-select"
                  value={option}
                  onChange={e => setOption(e.target.value)}
                  style={{ 
                    backgroundPosition: "calc(100% - 12px) center",
                    paddingRight: "30px"
                  }}
                >
                  <option value="email">Email</option>
                  <option value="phoneNumber">Phone Number</option>
                  <option value="paymentCode">Payment Code</option>
                </select>
              </div>
            </div>
          </div>
        </header>

        {/* Card */}

        <div className="card-body">
          <div className={classes.alldivs}>
            <div >
                <h5 className={classes.activePassive +" btn btn-dark btn-lg"} >Subscribers: {subscriberCount}</h5>
                <h5 className={classes.activePassive +" btn btn-dark btn-lg"} >Active: {asubscriberCount}</h5>
                <h5 className={classes.activePassive +" btn btn-dark btn-lg"} >Passive: {subscriberCount - asubscriberCount}</h5>
            </div>
            <div className={classes.subUnsub +" btn-dark btn-lg"}>
                <h5>Not subscribed: {users?.total - subscriberCount}</h5>
            </div>
          </div>

          {loading ? (
            <Loading />
          ) : error ? (
            <Message variant="alert-danger">{error}</Message>
          ) : (
            <>
                  <button style={{width:"100%",fontSize:"25px",marginBottom:"15px"}} className="btn btn-dark btn-lg">{users.total}</button>

<div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-3">

  {users?.data?.map((user) => (
    <div className="col" key={user.id}>
      <div className="card card-user shadow-sm">
        <div className="card-header">
          <div className=" d-flex justify-content-end">
            <div className="d-flex justify-content-end">
              <button
                onClick={() => onPartner(user)}
                className="btn btn-warning"
                disabled={(user.id === disabledId) || user.claims.includes('partner')}
              >
                Parnter
              </button>
            </div>
          </div>
          <Link to={`/user/${user.id}`}>
          <img
            className="img-md img-avatar"
            src="images/favicon.png"
            alt="User pic"
          />
             </Link>
      
       
        </div>
        <div className="card-body">
          <h5 className="card-title mt-5">{user.firstName}</h5>
          <div className="card-text text-muted">
            {user.claims && user.claims.includes("Admin") ? (
              <p className="m-0">Admin</p>
            ) : (
              <p className="m-0">Customer</p>
            )}

            <p>
              <a href={`mailto:${user.email}`}>{user.email}</a>
              <hr />
              <span>Phone: <a href={`tel:${user.phoneNumber}`}>{user.phoneNumber}</a> </span>
            </p>
            <hr />
            <b>{user.claims.filter(c => c !== "Free")?.join(", ")}</b>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>
            
            </>
  
          )}

          {/* nav */}
          <div className="d-flex justify-content-end">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next>"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={users?.total ? Math.ceil(users.total / 20) : 1}
              previousLabel="< previous"
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              renderOnZeroPageCount={1}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserComponent;
